import { render, staticRenderFns } from "./UpdatePasswordButton.vue?vue&type=template&id=34c5d6d2&"
import script from "./UpdatePasswordButton.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports